import { createToastInterface } from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const options = {
  position: "bottom-right",
  timeout: 3000,
};

const toast = createToastInterface(options);

export default toast;